<template>
  <div class="live-main">
    <div class="live-wrapper">
      <div class="body-wrapper">
        <div class="left">
          <div class="left-wrapper">
            <div class="avatar-wrapper">
              <UserCardToggle :id="data.user.id">
                <el-avatar shape="square" class="avatar" :style="isMine ? {cursor: 'unset'} : {}" :src="data.user.avatar"></el-avatar>
              </UserCardToggle>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="name">
            {{ getName(data) }}
          </div>
          <div class="date mine-text-grey">
            {{ data.date }}
          </div>
          <div class="body" ref="body">
            <TextAutoContainer class="text-content" :limit="350" :content="data.content"></TextAutoContainer>
            <div class="pictures-wrapper" v-if="data.pictures && data.pictures.length > 0">
              <el-image class="img" v-for="(item, index) in data.pictures" :preview-src-list="data.pictures"
                        :key="index"
                        :style="{height: pictureHeight + 'px'}"
                        :src="item"
                        fit="cover" :lazy="true"></el-image>
            </div>
            <div class="video-wrapper" v-if="data.videos && data.videos.length > 0">
              <Video :src="data.videos[0].video" :poster="data.videos[0].poster"></Video>
            </div>
            <div class="live-wrapper sub-live" v-if="data.type === 'FORWARD'">
              <div class="body-wrapper" v-if="data.forwardLive">
                <div class="left">
                  <div class="left-wrapper">
                    <div class="avatar-wrapper">
                      <UserCardToggle :id="data.forwardLive.user.id">
                        <el-avatar shape="square" class="avatar" :src="data.forwardLive.user.avatar"
                                   @click.native="$im.goSpace(data.forwardLive.user.id)"></el-avatar>
                      </UserCardToggle>
                    </div>
                  </div>
                </div>
                <div class="right">
                  <div class="name">
                    <el-link :underline="false" @click="$im.goSpace(data.forwardLive.user.id)">{{
                      getName(data.forwardLive)
                      }}
                    </el-link>
                  </div>
                  <div class="date mine-text-grey">
                    {{ data.forwardLive.date }}
                  </div>
                  <div class="body" ref="forwardBody">
                    <TextAutoContainer class="text-content" :limit="250"
                                       :content="data.forwardLive.content"></TextAutoContainer>
                    <div class="pictures-wrapper"
                         v-if="data.forwardLive.pictures && data.forwardLive.pictures.length > 0">
                      <el-image class="img" v-for="(item, index) in data.forwardLive.pictures"
                                :preview-src-list="data.forwardLive.pictures" :key="index"
                                :style="{height: forwardPictureHeight + 'px'}"
                                :src="item"
                                fit="cover" :lazy="true"></el-image>
                    </div>
                    <div class="video-wrapper" v-if="data.forwardLive.videos && data.forwardLive.videos.length > 0">
                      <Video :src="data.forwardLive.videos[0].video"
                             :poster="data.forwardLive.videos[0].poster"></Video>
                    </div>
                  </div>
                  <div class="option">
                    <div class="info mine-text-grey">
                      <span>{{ data.forwardLive.browseSum }} 浏览</span>
                      <el-divider direction="vertical"></el-divider>
                      <span>{{ data.forwardLive.likeSum }} 点赞</span>
                    </div>
                  </div>
                </div>
              </div>
              <el-empty v-else :image-size="200" description="说说已删除或不可见"></el-empty>
            </div>
          </div>
        </div>
        <div class="dropdown" v-if="enableHide || enableCollect || enableDelete">
          <el-dropdown trigger="click" size="medium" @command="dropdownEvent">
            <i class="mine-icon el-icon-more"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="hide" v-if="enableHide">
                <i class="el-icon-view"></i>隐藏该动态
              </el-dropdown-item>
              <el-dropdown-item command="collect" v-if="enableCollect && data.collectStatus === 'N'">
                <i class="el-icon-star-off"></i>收藏
              </el-dropdown-item>
              <el-dropdown-item command="unCollect" v-if="enableCollect && data.collectStatus === 'Y'">
                <i class="el-icon-star-on"></i>取消收藏
              </el-dropdown-item>
              <el-dropdown-item command="delete" v-if="enableDelete">
                <i class="el-icon-delete"></i>删除说说
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="option">
        <div class="info mine-text-grey">
          <span><i class="el-icon-cpu"></i> {{ data.device === 'WEB' ? '来自WEB端' : '' }}</span>
          <el-divider direction="vertical" v-if="!liveIsPrivate"></el-divider>
          <span v-if="!liveIsPrivate"><i class="el-icon-view"></i> {{ data.browseSum }} 浏览</span>
          <el-divider direction="vertical" v-if="!liveIsPrivate"></el-divider>
          <span v-if="!liveIsPrivate"><i class="el-icon-thumb"></i> {{ data.likeSum }} 点赞</span>
          <el-divider direction="vertical" v-if="locationText"></el-divider>
          <span v-if="locationText"><i class="el-icon-location-information"></i> {{ locationText }}</span>
          <el-divider direction="vertical" v-if="visibilityTextShow"></el-divider>
          <span v-if="visibilityTextShow"><i class="el-icon-lock"></i> {{ visibilityTextShow }}</span>
        </div>
        <div class="option-menu">
          <a class="item like" :class="[{liked: data.likeStatus === 'Y'}, {'like-animation': likeAnimationFlag}]"
             title="赞"
             @mouseenter="mouseenter($event, 'like')" @mouseleave="mouseleave($event)" @click="likeClick($event)"></a>
          <el-divider direction="vertical"></el-divider>
          <a class="item comment" title="评论" @mouseenter="mouseenter($event, 'comment')"
             @mouseleave="mouseleave($event)" @click="$refs.commentEditorC.trigger()"></a>
          <el-divider direction="vertical" v-if="liveCanForward"></el-divider>
          <a class="item forward" title="转发" v-if="liveCanForward" @mouseenter="mouseenter($event, 'forward')"
             @click="forwardShow"
             @mouseleave="mouseleave($event)"></a>
        </div>
      </div>
      <div class="likes-person" v-if="data.likeInfo">{{ data.likeInfo }}</div>
      <TriggerDisplayContainer ref="commentEditorC" class="comment-editor" @callback="$refs.liveCommentEditor.focus()">
        <template v-slot:default>
          <CommentEditor @submit="submitLiveComment" :enableAt="false" :enableOnTop="isMine" ref="liveCommentEditor"
                         placeholder="说点什么..." :submitFlag="liveCommentSubmitFlag"></CommentEditor>
        </template>
      </TriggerDisplayContainer>
      <TriggerDisplayContainer class="forward-editor" ref="forwardEditorC" @callback="$refs.forwardEditor.focus()">
        <template v-slot:default>
          <ForwardEditor ref="forwardEditor" :forwardInfo="getForwardInfo()" :disabled="forwardSubmitFlag"
                         @submit="submitForward"></ForwardEditor>
        </template>
      </TriggerDisplayContainer>
      <el-divider content-position="left" v-if="this.data.comments.length > 0">
        <div class="mine-icon" @click="commentSpreadFlag = !commentSpreadFlag">
          <span>评论区</span>
          <i :class="commentSpreadFlag ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
<!--        <span v-else>暂无评论</span>-->
      </el-divider>
      <el-collapse-transition>
        <div class="comment-area" v-show="commentSpreadFlag">
          <LiveCommentItem class="item" v-for="(item, index) in data.comments" :data="item" :masterId="data.user.id"
                           :key="item.id" @delete="deleteComment(index)"></LiveCommentItem>
          <div class="comment-more-wrapper" v-show="!commentEndFlag">
            <el-button type="text" size="mini" @click="loadComment" :loading="commentLoadingFlag">更多评论</el-button>
          </div>
        </div>
      </el-collapse-transition>
    </div>
  </div>
</template>

<script>
    import TextAutoContainer from '../baseComponent/TextAutoContainer'
    import CommentEditor from '../component/CommentEditor'
    import Video from '../component/Video'
    import UserCardToggle from '../userCard/UserCardToggle'
    import LiveCommentItem from './LiveCommentItem'
    import ForwardEditor from './ForwardEditor'
    import TriggerDisplayContainer from "../baseComponent/TriggerDisplayContainer"
    import IsMine from "../baseComponent/IsMine"
    import bus from "../../js/bus/bus";
    import {clone} from "../../js/utils/objUtils";
    import setting from "../../config/setting";

    export default {
        name: "LivePlate",
        mixins: [IsMine],
        components: {
            TextAutoContainer,
            CommentEditor,
            Video,
            UserCardToggle,
            LiveCommentItem,
            ForwardEditor,
            TriggerDisplayContainer
        },
        props: {
            data: {
                type: Object,
                required: true
            },
            //显示说说隐藏操作
            enableHide: {
                type: Boolean,
                default: false
            },
            //显示说说收藏操作
            enableCollect: {
                type: Boolean,
                default: false
            },
            //显示说说删除操作
            enableDelete: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                commentSpreadFlag: false,
                pictureHeight: null,
                forwardPictureHeight: null,
                collectTriggerFlag: false,
                likeTriggerFlag: false,
                likeAnimationFlag: false,
                liveCommentInitFlag: false,
                liveCommentShowFlag: false,
                liveCommentSubmitFlag: false,
                forwardInitFlag: false,
                forwardShowFlag: false,
                forwardSubmitFlag: false,
                commentLoadingFlag: false,
                commentEndFlag: false,
                commentLoadPageSize: 5,
            }
        },
        created() {
            if (!this.data.comments) {
                this.data.comments = [];
            }
            //如果评论小于5条，则视为没有更多评论
            this.commentEndFlag = this.data.comments.length < 5;
            this.commentSpreadFlag = this.data.comments.length > 0;
            this.setUserId(this.data.user.id);
        },
        mounted() {
            //如果有图片，则动态计算九宫格图片高度
            if (this.$refs.body) {
                this.pictureHeight = this.$refs.body.offsetWidth / 3.2;
            }
            if (this.$refs.forwardBody) {
                this.forwardPictureHeight = this.$refs.forwardBody.offsetWidth / 3.2;
            }
        },
        methods: {
            mouseenter({currentTarget}, flag) {
                switch (flag) {
                    case 'like':
                        return currentTarget.style['background-position'] = "-1003px -1028px";
                    case 'comment':
                        return currentTarget.style['background-position'] = "-1003px -1144px";
                    case 'forward':
                        return currentTarget.style['background-position'] = "-1003px -1227px";
                }
            },
            mouseleave({currentTarget}) {
                currentTarget.style['background-position'] = "";
            },
            getName(data) {
                return data.user.remarks ? data.user.remarks : (data.user.name ? data.user.name : '佚名')
            },
            //提交说说评论
            submitLiveComment(content, pictures, onTop) {
                if (!content.trim() && !pictures[0]) {
                    return this.$im.showMessage("请输入评论内容", {icon: 5});
                }
                this.liveCommentSubmitFlag = true;
                this.$im.post("/SPACE/v1/live-comments", {
                    liveId: this.data.id,
                    content: content,
                    picture: pictures[0],
                    onTop: onTop ? 'Y' : 'N'
                }, true, (id) => {
                    this.$im.showMessage("评论成功", {icon: 1});
                    this.$refs.liveCommentEditor.clean();
                    this.$refs.commentEditorC.hide();
                    this.$im.getInfo((info) => {
                        let newItem = {
                            user: info,
                            id: id,
                            content: content,
                            data: "1秒前",
                            replies: [],
                            picture: pictures[0] ? setting.oosPublicDomain + pictures[0] : null,
                            onTop: onTop ? 'Y' : 'N'
                        };
                        if (onTop) {
                            this.data.comments.unshift(newItem);
                        } else if (this.commentEndFlag) {
                            this.data.comments.push(newItem);
                        }
                        if (this.data.comments.length === 1) {
                            this.commentSpreadFlag = true;
                        }
                    });
                }, () => {
                    this.liveCommentSubmitFlag = false;
                })
            },
            likeClick({currentTarget}) {
                if (this.likeTriggerFlag)
                    return this.$im.showMessage("请勿频繁点赞", {icon: 5});
                this.likeTriggerFlag = true;
                if (this.data.likeStatus === 'Y') {
                    this.data.likeStatus = 'N';
                    this.likeAnimationFlag = false;
                    this.data.likeSum--;
                    this.$im.delete("/SPACE/v1/lives/" + this.data.id + "/like", null, true, null, () => {
                        this.likeTriggerFlag = false;
                    }, null);
                    if (this.data.forwardLive) {
                        this.data.forwardLive.likeSum--;
                        this.$im.delete("/SPACE/v1/lives/" + this.data.forwardLive.id + "/like", null, true);
                    }
                } else {
                    this.data.likeStatus = 'Y';
                    this.likeAnimationFlag = true;
                    this.data.likeSum++;
                    this.$im.post("/SPACE/v1/lives/" + this.data.id + "/like", null, true, null, () => {
                        this.likeTriggerFlag = false;
                    }, null);
                    if (this.data.forwardLive) {
                        this.data.forwardLive.likeSum++;
                        this.$im.post("/SPACE/v1/lives/" + this.data.forwardLive.id + "/like", null, true);
                    }
                }
            },
            dropdownEvent(command) {
                switch (command) {
                    case "hide":
                        this.$emit("hide");
                        break;
                    case "collect":
                        if (this.collectTriggerFlag)
                            return;
                        this.collectTriggerFlag = true;
                        this.$im.post("/SPACE/v1/lives/" + this.data.id + "/collect", null, true, () => {
                            this.data.collectStatus = 'Y';
                            this.$im.showMessage("收藏成功", {icon: 1});
                        }, () => {
                            this.collectTriggerFlag = false;
                        }, (msg) => {
                            this.$im.showMessage(msg, {icon: 5});
                        });
                        break;
                    case "unCollect":
                        if (this.collectTriggerFlag)
                            return;
                        this.collectTriggerFlag = true;
                        this.$im.delete("/SPACE/v1/lives/" + this.data.id + "/collect", null, true, () => {
                            this.data.collectStatus = 'N';
                            this.$im.showMessage("已取消收藏", {icon: 1});
                        }, () => {
                            this.collectTriggerFlag = false;
                        }, (msg) => {
                            this.$im.showMessage(msg, {icon: 5});
                        });
                        break;
                    case "delete":
                        this.$emit("delete");
                        break;
                }
            },
            deleteComment(index) {
                this.$im.showConfirm("确认删除该评论？", () => {
                    this.$im.delete("/SPACE/v1/live-comments/" + this.data.comments[index].id, null, true, () => {
                        this.data.comments.splice(index, 1);
                    })
                })
            },
            //获取说说转发缩略信息
            getForwardInfo() {
                let f = function (live) {
                    let str = "";
                    if (live.content && live.content.length > 50) {
                        str += live.content.substr(0, 50) + "...";
                    } else {
                        str += live.content;
                    }
                    if (live.pictures && live.pictures.length > 0) {
                        for (let i = 0; i < live.pictures.length; i++) {
                            str += "[图片]";
                        }
                    }
                    if (live.videos && live.videos.length > 0) {
                        str += "[视频]";
                    }
                    return str;
                }
                if (this.data.forwardLive) {
                    return f(this.data.forwardLive);
                }
                return f(this.data);
            },
            forwardShow() {
                this.$refs.forwardEditorC.trigger();
            },
            //提交说说转发
            submitForward(live) {
                this.forwardSubmitFlag = true;
                let forwardId = this.data.forwardLive ? this.data.forwardLive.id : this.data.id;
                this.$im.post("/SPACE/v1/lives/" + forwardId + "/forward", live, true, (id) => {
                    this.$refs.forwardEditor.clean();
                    this.$refs.forwardEditorC.trigger();
                    if (live.delay !== 'NO_DELAY') {
                        return this.$im.showMessage("延迟转发成功", {icon: 1});
                    }
                    this.$im.showMessage("转发成功", {icon: 1});
                    let newObj = clone(live);
                    newObj.id = id;
                    newObj.type = 'FORWARD';
                    newObj.date = '1秒前';
                    newObj.device = 'WEB';
                    newObj.browseSum = 0;
                    newObj.likeStatus = 'N';
                    newObj.likeSum = 0;
                    newObj.likeInfo = "";
                    newObj.collectStatus = "N";
                    newObj.forwardLive = this.data.forwardLive ? this.data.forwardLive : this.data;
                    newObj.pictures = newObj.pictures.map(item => {
                        return setting.oosPublicDomain + item;
                    });
                    newObj.videos = newObj.videos.map(item => {
                        return {'video': setting.oosPublicDomain + item};
                    });
                    this.$im.getInfo((info) => {
                        newObj.user = info;
                        bus.$emit("submitList", newObj);
                    });
                }, () => {
                    this.forwardSubmitFlag = false;
                })
            },
            loadComment() {
                let comments = this.data.comments;
                this.commentLoadingFlag = true;
                this.$im.get("/SPACE/v1/live-comments", {
                    liveId: this.data.id,
                    pageSize: this.commentLoadPageSize,
                    afterId: comments.length > 0 ? comments.slice(-1)[0].id : null
                }, true, (list) => {
                    comments.push(...list);
                    this.commentEndFlag = list.length < this.commentLoadPageSize;
                }, () => {
                    this.commentLoadingFlag = false;
                }, (msg) => {
                    this.$im.showMessage(msg, {icon: 5})
                })
            },
        },
        computed: {
            locationText() {
                if (this.data.location) {
                    let text = this.data.location.country === '中国' ?
                        (this.data.location.city || '') + ' ' + (this.data.location.district || '') :
                        (this.data.location.country || '') + ' ' + (this.data.location.city || '') + ' ' + (this.data.location.district || '');
                    return text.trim();
                }
                return '';
            },
            liveIsPrivate() {
                return this.data.visibility === "MYSELF_ONLY";
            },
            //说说能否被转发
            liveCanForward() {
                //不是我且可见度为"ANYONE"
                return !this.isMine && this.data.visibility === "ANYONE";
            },
            visibilityTextShow() {
                switch (this.data.visibility) {
                    case "ANYONE":  //不显示
                        return "";
                    case "INHERIT_SPACE":
                        return "空间访客可见";
                    case "FRIENDLY_ONLY":
                        return "仅好友可见";
                    case "FRIENDLY_PART":
                        return "部分好友可见";
                    case "FRIENDLY_PART_NOT":
                        return "部分好友不可见";
                    case "MYSELF_ONLY":
                        return "仅自己可见";
                }
            },
        }
    }
</script>

<style scoped>
  .live-wrapper {
    padding: 15px;
  }

  .body-wrapper {
    display: flex;
    position: relative;
  }

  .body-wrapper .left {
    margin-right: 8px;
  }

  .body-wrapper .right {
    flex-grow: 1;
  }

  .body-wrapper .right > :not(:last-child) {
    margin-bottom: 5px;
  }

  .body-wrapper .dropdown {
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
  }

  .mine-icon {
    border-radius: 4px;
    padding: 0 2px;
    cursor: pointer;
  }

  .mine-icon:hover {
    background-color: #CCC;
  }

  .mine-text-grey {
    font-size: 12px;
    color: #666;
  }

  .body > * {
    margin-bottom: 5px;
  }


  .name {
    font-weight: bold;
    color: #606266;
  }

  .avatar {
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  }

  .sub-live {
    background: #eee;
    border-radius: 4px;
  }


  .pictures-wrapper {
    font-size: 0;
  }

  .pictures-wrapper .img {
    width: 32%;
    margin: 0 2px 2px 0;
  }

  .video-wrapper {
    width: 95%;
    border-radius: 4px;
    overflow: hidden;
  }


  .option {
    display: flex;
    justify-content: space-between;
  }

  .option .info {
    line-height: 25px;
  }


  .option .option-menu {
    user-select: none;
  }

  .option-menu .item {
    width: 25px;
    height: 25px;
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
  }

  .like {
    background-image: url("/static/img/icons.png");
    background-position: -1003px -996px;
  }

  .liked {
    background-position: -1003px -1060px !important;
  }

  .like-animation {
    animation: .7s shake;
  }

  @keyframes shake {
    0% {
      transform: rotate(9deg);
    }
    50% {
      transform: rotate(-9deg);
    }
    100% {
      transform: rotate(9deg);
    }
  }

  .comment {
    background-image: url("/static/img/icons.png");
    background-position: -1003px -1099px;
  }

  .forward {
    background-image: url("/static/img/icons.png");
    background-position: -1003px -1187px;
  }


  .likes-person {
    font-size: 12px;
    color: #0a596f;
  }

  .comment-editor, .forward-editor {
    padding: 12px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    margin-top: 8px;
  }

  .comment-area {
    margin: 0 20px;
  }

  .comment-area .item {
    padding: 6px 0;
    border-bottom: 1px solid #DCDFE6;
  }

  .comment-more-wrapper {
    text-align: center;
  }


</style>



// WEBPACK FOOTER //
// src/view/component/LivePlate.vue